import { FC, HTMLAttributes } from 'react';
import FocusTrap from 'focus-trap-react';

import { useBodyClass } from '@belong/react-hooks/useBodyClass';

import { ChatDialog } from './ChatWindow.styles';

// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/dialog_role
// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-modal

type TChatWindowProps = HTMLAttributes<HTMLDialogElement> & { isFullScreen?: boolean };

// Essentially synchronizes focus-trapping + <body> scroll-locking + `aria-modal` attribute, via the `isFullScreen` prop
export const ChatWindow: FC<TChatWindowProps> = ({ isFullScreen, ...otherProps }) => {
  // This can be replaced with useLockBodyScroll() from utils once the GlobalStyles it relies
  // on have been deployed to all parent apps (currently chat is deploy as a .js file, which
  // may be out of sync with the parent/host app)
  useBodyClass('has-fullscreen-chat', isFullScreen);

  return (
    <FocusTrap active={isFullScreen}>
      <ChatDialog isFullScreen={isFullScreen} aria-modal={isFullScreen} {...otherProps} open />
    </FocusTrap>
  );
};
ChatWindow.displayName = 'ChatWindow';
